//=> Import React
import React, { useState } from "react";

//=> Import plugins
import { StaticImage } from "gatsby-plugin-image";

//=> Import component
import Layout from "../../component/Layout";
import Header from "../../component/Header";
import NavBar from "../../component/NavBar";
import Footer from "../../component/Footer";
import Divider from "../../component/Divider";
import Workshop from "../../component/Workshop";
import Modal from "../../component/Modal";
import InfoBanner from "../../component/InfoBanner";
import SEO from '../../component/SEO'
//=> Import Styles
import { titleAtelier, title, presentation, contentContainer, photoAtelier } from "./styles.module.scss"

//=> Component
const Atelier = () => {

  // Open close modal with info event  => 
  const [infoEvent, setInfoEvent] = useState({})
  const [modalIsOpen, setModalIsOpen] = useState(false)


  return (

    <Layout>
      <SEO title={"Atelier"} />

      {modalIsOpen && <Modal {...infoEvent[0].node} closeModal={setModalIsOpen} />}
      <title>Atelier</title>
      <Header />
      <NavBar />
      <div className={contentContainer}>


        <InfoBanner />
        <h2 className={titleAtelier}> L'atelier de Berthe aux Pâquerettes</h2>
        <div >
          <StaticImage className={photoAtelier} src="https://picsum.photos/seed/picsum/1220/500" alt="#" />
          <h3 className={title}>Présentation</h3>
          <Divider />
          <div className={presentation}>
            <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Impedit distinctio nesciunt necessitatibus sed fugiat perspiciatis praesentium mollitia eaque deserunt nisi, doloribus consectetur maiores, cumque nam quas quia dolore quae eveniet.</p>
            <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Impedit distinctio nesciunt necessitatibus sed fugiat perspiciatis praesentium mollitia eaque deserunt nisi, doloribus consectetur maiores, cumque nam quas quia dolore quae eveniet.</p>
          </div>

          <h3 className={title}>Prix</h3>
          <Divider />
          <p>20€ par personne</p>

          <h3 className={title}>Pour s'inscrire à l'un des ateliers</h3>
          <Divider />
          <p>➡ Par mail: <a href="cindypenez@gmail.com">cindypenez@gmail.com</a></p>
          <p>➡ Par téléphone: <a href="#">06 ** ** ** **</a></p>
          <p>➡ Directement en magasin</p>

          {/* Ateliers*/}
          <Workshop setModalIsOpen={setModalIsOpen} modalIsOpen={modalIsOpen} setInfoEvent={setInfoEvent} />

        </div>
      </div>
      <Footer />
    </Layout>
  );
};

export default Atelier;
